<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2016 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2016</p>
<p class="crt">Paperback edition 2019</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">28 27 26 25 24 23 22 21 20 19    1 2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-39428-2 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-63969-7 (paper)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-39431-2 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: <a class="url" href="https://doi.org/10.7208/chicago/9780226394312.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226394312.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Bartlett, Robert C., 1964–author.</p>
<p class="cip">Title: Sophistry and political philosophy : Protagoras’ challenge to Socrates / Robert C. Bartlett.</p>
<p class="cip">Description: Chicago : The University of Chicago Press, 2016. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: lccn 2016002819| <span class="sm">ISBN</span> 9780226394282 (cloth : alk. paper) | <span class="sm">ISBN</span> 9780226394312 (e-book)</p>
<p class="cip">Subjects: lcsh: Plato. Protagoras. | Plato. Theaetetus. | Sophists (Greek philosophy) | Protagoras. | Political science—Philosophy. | Philosophy, Ancient.</p>
<p class="cip">Classification: <span class="sm">LCC</span> <span class="sm">B</span>382.<span class="sm">B3</span>7 2016 | <span class="sm">DDC</span> 184—dc23 <span class="sm">LC</span> record available at <a class="url" href="http://lccn.loc.gov/2016002819" target="_blank">http://lccn.loc.gov/2016002819</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of <span class="sm">ANSI/NISO</span> <span class="sm">Z</span>39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bartlett-SOPHISTRY-pbk-update-0004.vue?16c40b60